import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {marketRegister} from "../../services/marketRegister";
import {cartRegister} from "../../services/cartRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {BeatLoader} from "react-spinners";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class BoosterFooter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: null,
            market: null,
            user: null,
            success: false,
            markets: [],
            languages: [],
            trending: [],
            email: ""
        };
    };

    componentWillMount() {
        this._updateLang();
        this._updateLanguages();
        this._updateMarket();
        this._updateMarkets();
        this._updateTrending();
        this._updateDate();
        this._updateUser;
    }

    _updateLang() {
        this.setState({lang: langRegister.lang()});
    }

    _updateLanguages() {
        this.setState({languages: JSON.parse(salesChannelRegister.get("languages"))});
    }

    _updateMarket() {
        this.setState({market: salesChannelRegister.get("market")});
    }

    _updateMarkets() {
        this.setState({markets: marketRegister.allMarkets()});
    }

    _updateTrending() {
        dataRegister.publicCampaigns(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
            console.log(response);
            let trending = [];
            try {
                for (let i = 0; i < response.length; i++) {
                    if (i < 6) {
                        trending.push(response[i])
                    }
                }
            } catch (e) {
            }
            this.setState({trending: trending});
        }, (error) => {
        });
    }

    _updateDate() {
        let date = new Date();
        let year = date.getFullYear();
        this.setState({year: year});
    }

    _updateUser() {
        let user = userRegister.get();
        this.setState({user: user});
    }

    _setLang(lang) {
        this.setState({lang: lang}, () => {
            langRegister.set(lang);
            this.props.props.history.replace("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
            window.location.reload();
        });
    }

    list() {
        window.location.replace("https://" + dataRegister.getDomain() + "/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
    }

    go(option) {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + option);
            window.scrollTo(0, 0);
        } catch (error) {
            console.log(error);
        }

    }

    _newsletter(){
        if(!this.state.isLoading){
            this.setState({error: false, success: false}, () => {
                if(this._emailValidation(this.state.email)){
                    this.setState({isLoading: true});
                    let data = {email: this.state.email, name: this.state.email, subject: salesChannelRegister.get("name")+" newsletter request", message: 'ae'};
                    dataRegister.industryRequest('ae', salesChannelRegister.get("name"), data).then((response) => {
                        this.setState({
                            isLoading: false,
                            email: "",
                            success: true
                        });
                    }, (error) => {
                        this.setState({isLoading: false});
                    });

                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Subscribed Newsletter', label: 'Footer'});
                        ReactGA4.event({category: 'User', action: 'Subscribed Newsletter', label: 'Footer'});
                        //console.log("Fire event Newsletter");
                    }

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.trackCustom('SubmitNewsletter');
                    }

                }else{
                    this.setState({error: true});
                }
            });
        }
    }

    _terms(link) {
        window.open('https://legal.' + dataRegister.domain + "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/" + link + "/" + salesChannelRegister.get("name"), '_blank');
    }

    _help() {
        window.open('https://help.' + dataRegister.domain + "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/" + salesChannelRegister.get("name"), '_blank');
    }

    openIndustry(item){
        if(item.landingpage_id){
            try {
                window.open('https://' + 'lp.' + dataRegister.domain + '/' + item.landingpage_id, '_blank');
            }catch (e) {}
        }
    }


    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _renderLanguage(lang) {
        let value = "";
        for (let i = 0; i < this.state.languages.length; i++) {
            if (this.state.languages[i].code === lang) {
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    renderIndustry(industry) {
        let string = '';
        let region = '';

        /*
        if (industry.ad_region.length > 20) {
            region = industry.ad_region.substring(0, 20) + '...';
        } else {
            region = industry.ad_region;
        }

        string = string + industry.industry + ', ' + region + " | ";
        string = string + industry.company_name;
        /*/

        if (industry.ad_region !== null) {
            region = industry.ad_region.split(', ');
            string = string + industry.industry + ', ' + region[0] + " | ";
        } else {
            string = string + industry.industry + ', ' + industry.ad_region + " | ";
        }

        string = string + industry.company_name;
        return string;
    }

    _renderText(item) {
        return langRegister.get("footer", item);
    }

    renderFacebookPageLink(){
        try {
            if(window.location.href.indexOf("propertybooster") !== -1){
                return 'https://www.facebook.com/uae.propertybooster'
            }else if(window.location.href.indexOf("boostabostad") !== -1){
                return 'https://www.facebook.com/boostabostad'
            }else if(window.location.href.indexOf("yieldlock") !== -1){
                return 'https://www.facebook.com/yieldlock'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }

    renderInstagramPageLink(){
        try {
            if(window.location.href.indexOf("propertybooster") !== -1){
                return 'https://www.instagram.com/uae.propertybooster'
            }else if(window.location.href.indexOf("boostabostad") !== -1){
                return 'https://www.instagram.com/boostabostad'
            }else if(window.location.href.indexOf("yieldlock") !== -1){
                return 'https://www.instagram.com/yieldlock'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }

    render() {
        return (
            <div className={Styles.footer}>
                <div className={Styles.footerContainer}>
                    <div className={Styles.desktopBorder} style={salesChannelRegister.get("name") === "yieldlock"?{borderColor: '#E65032'}:{}}/>
                    <img className={Styles.footerImageMobile} src={salesChannelRegister.get('logo_dashboard')}/>
                    <div className={Styles.footerInner}>
                        <div className={Styles.sectionOne}>
                            <div onClick={() => this.list()} className={Styles.sectionOneItemOne}>
                                {this._renderText("item_1")}
                            </div>
                            <div onClick={() => this.go("/")} className={Styles.sectionOneItemOne}>
                                {this._renderText("item_2")}
                            </div>
                            <div onClick={() => this.go("/about")} className={Styles.sectionOneItemOne}>
                                {this._renderText("item_3")}
                            </div>
                            <a href={"mailto:support@"+salesChannelRegister.get("name")+"."+salesChannelRegister.get("market")+"?Subject=" + this._renderText("item_25")}
                               target="_top" className={Styles.sectionOneItemOneMiddle}>
                                {this._renderText("item_4")}
                            </a>
                            {
                                !this.state.user &&
                                <div onClick={() => this.go("/login")} className={Styles.sectionOneItemOne}>
                                    {this._renderText("item_5")}
                                </div>
                            }
                            <div onClick={() => this.go("/reseller")} className={Styles.sectionOneItemOneMiddle}>
                                {this._renderText("item_6")}
                            </div>
                            <div className={cx(Styles.dropdown, Styles.dropdownWhite)}>
                                <select className={Styles.dropdownSelection} value={this.state.lang}
                                        onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item) => {
                                            return (
                                                <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={cx(Styles.dropdownText, Styles.dropdownTextWhite)}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow}
                                     src={require("../../assets/images/arrow_white.png")}/>
                            </div>
                        </div>
                        <div className={Styles.sectionThree}>
                            <div className={Styles.sectionThreeItemOneHeader}>
                                {this._renderText("item_11")}
                            </div>
                            {
                                this.state.trending.map((item) => {
                                    return (
                                        <div onClick={() => this.openIndustry(item)} className={Styles.sectionThreeItemOne}>
                                            {this.renderIndustry(item)}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={Styles.sectionFour}>
                            <img className={Styles.sectionFourLogo} src={salesChannelRegister.get('logo_dashboard')}/>
                        </div>
                    </div>
                    <div className={Styles.footerBottom}>
                        <div className={Styles.socialIcons}>
                            <a className={Styles.socialIcon} href={this.renderFacebookPageLink()} target={"_blank"}>
                                    <img className={Styles.socialIconFb} src={require("../../assets/images/facebook_icon.png")}/>
                            </a>
                            <a className={Styles.socialIcon} href={this.renderInstagramPageLink()} target={"_blank"}>
                                    <img className={Styles.socialIconInstagram} src={require("../../assets/images/instagram_icon.png")}/>
                            </a>
                            {
                                false &&
                                <div className={Styles.socialIcon}>
                                    <img className={Styles.socialIconLinkedIn} src={require("../../assets/images/linkedin_icon.png")}/>
                                </div>
                            }
                            {
                                false &&
                                <div className={Styles.socialIcon}>
                                    <img className={Styles.socialIconTwitter}
                                         src={require("../../assets/images/twitter_icon.png")}/>
                                </div>
                            }
                        </div>
                        <div className={Styles.inputContainer}>
                            <input onFocus={() => this.setState({success: false})} disabled={this.state.isLoading} value={this.state.email} onChange={(event) => this.setState({email: event.target.value.toLowerCase(), error: false})} placeholder={this._renderText("item_17")} className={Styles.inputContainerInput}/>
                            <div onClick={() => this._newsletter()} className={Styles.inputContainerButton}>
                                {
                                    !this.state.isLoading && this.state.success && !this.state.error &&
                                    this._renderText("item_23")
                                }
                                {
                                    !this.state.isLoading && !this.state.success && !this.state.error &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.isLoading && this.state.error &&
                                    <span className={Styles.inputContainerButtonError} style={salesChannelRegister.get("name") === "yieldlock"?{color: '#E65032'}:{}}>{this._renderText("item_24")}</span>
                                }
                                {
                                    this.state.isLoading &&
                                    <BeatLoader size={15} color={'#ffffff'} loading={true}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={Styles.bottomText} style={salesChannelRegister.get("name") === "yieldlock"?{borderColor: '#E65032'}:{}}>
                        <span className={Styles.bottomTextItem}
                              onClick={() => this._terms("terms")}>{this._renderText("item_19")}</span> | <span
                        className={Styles.bottomTextItem}
                        onClick={() => this._terms("privacy")}>{this._renderText("item_20")}</span> | <span
                        className={Styles.bottomTextItem}
                        onClick={() => this._terms("acceptance")}>{this._renderText("item_21")}</span> | <span>©&nbsp;{this.state.year}&nbsp;{salesChannelRegister.get("saleschannel_name")}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterFooter;


// WEBPACK FOOTER //
// ./src/components/booster-footer/component.js